import { gql } from '@apollo/client';

export const GET_MITARBEITER_PERSONAL_IDS = gql`
  query mitarbeiter_getMitarbeiterPersonalIds($standortId: String!) {
    mitarbeiter_mitarbeiterByStandortIds(standortIds: [$standortId]) {
      vorname
      nachname
      personalnummer
      e2nId
    }
  }
`;
